module.exports = __webpack_public_path__ + "img/italy-endocrine-nutritional-metabolic-diseases-male.113cb735.png";